const locale = {
  common: {
    loading: "Loading...",
    error: "Error: {{message}}",
    noDataFound: "No data found",
    processing: "Processing...",
    search: "Search",
    actions: "Actions",
    save: "Save",
    saving: "Saving...",
    update: "Update",
    updating: "Updating...",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    create: "Create",
    submit: "Submit",
    close: "Close",
    previous: "Previous",
    next: "Next",
    page: "Page {{current}} of {{total}}",
    confirmation: "Confirmation",
    expand: "Expand",
    collapse: "Collapse",
    yes: "Yes",
    no: "No",
    on: "On",
    off: "Off",
    user: "User",
    errorObj: {
      fieldRequired: "This field is required",
      connectionError: "Connection error",
      unknownError: "Unknown error",
    },
    notSpecified: "Not specified",
    refresh: "Refresh",
    copied: "Copied!",
    filter: "Filter",
    download: "Download",
    reportPassword:
      "Please enter the user's year of birth to download the report",
  },
  calendar: {
    weekday0: "Sun",
    weekday1: "Mon",
    weekday2: "Tue",
    weekday3: "Wed",
    weekday4: "Thu",
    weekday5: "Fri",
    weekday6: "Sat",
    month0: "January",
    month1: "February",
    month2: "March",
    month3: "April",
    month4: "May",
    month5: "June",
    month6: "July",
    month7: "August",
    month8: "September",
    month9: "October",
    month10: "November",
    month11: "December",
  },
  navigation: {
    dashboard: "Dashboard",
    bookings: "Bookings",
    labTests: "Tests",
    users: "Users",
    settings: "Settings",
    logout: "Logout",
    profileSettings: "Profile Settings",
    profile: "Profile",
    pharmacySettings: "Pharmacy Settings",
    teamEmployees: "Team / Employees",
    labTestBookings: "Test Bookings",
    pharmacyDetails: "Pharmacy Details",
    labTestAvailable: "Test Available",
    schedules: "Schedules",
    changePassword: "Change Password",
    tutorials: "Documents",
    pharmacyAppointments: "Pharmacy Appointments",
  },
  pharmacyAppointments: {
    title: "Pharmacy Appointments",
    subtitle: "Manage your appointment types and customer bookings",
    myAppointments: "My Appointments",
    customerBookings: "Customer Bookings",
    createNewAppointment: "Create New Appointment Name",
    createFirstAppointment: "Create Your First Appointment Type",
    searchAppointments: "Search appointments...",
    searchBookings: "Search bookings...",
    noAppointmentsFound: "No appointments found matching your search.",
    noAppointmentsYet: "No appointment types created yet.",
    noBookingsFound: "No bookings found matching your filters.",
    noBookingsYet: "No bookings found.",
    description: "Description",
    price: "Price",
    discountEnabled: "Enable Discount",
    discountType: "Discount Type",
    discountValue: "Discount Value",
    startDate: "Start Date",
    endDate: "End Date",
    startTime: "Start Time",
    endTime: "End Time",
    intervalMinutes: "Interval (minutes)",
    isRecurring: "Recurring Appointment",
    recurringDays: "Recurring Days",
    isActive: "Active",
    visibleOnBookingPage: "Visible on booking page",
    visibleOnBookingPageHint:
      "When off, customers cannot book this type online. Pharmacy staff can still book it for users.",
    blockTestingSlots: "Block testing slots",
    blockTestingSlotsHint:
      "When on, booked appointments block lab test time slots in the same room. Turn off if this appointment uses a different room.",
    staffOnly: "Staff only",
    hiddenFromCustomers: "Hidden from customers",
    statusSettings: "Status & visibility",
    available: "Available",
    hours: "Hours",
    interval: "Interval",
    recurring: "Recurring",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    completed: "Completed",
    cancelled: "Cancelled",
    expired: "Expired",
    upcoming: "Upcoming",
    holiday: "Holiday",
    closed: "Closed",
    customer: "Customer",
    appointment: "Appointment",
    dateTime: "Date & Time",
    actions: "Actions",
    userDetails: "User Details",
    expand: "Expand",
    collapse: "Collapse",
    previous: "Previous",
    next: "Next",
    page: "Page",
    of: "of",
    allStatuses: "All Statuses",
    allDates: "All Dates",
    today: "Today",
    past: "Past",
    future: "Future",
    confirmDelete: "Are you sure you want to delete this appointment?",
    cancelReason: "Please provide a reason for cancellation:",
    reason: "Reason",
    started: "Started",
    completedAt: "Completed",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    percentage: "Percentage",
    flatAmount: "Flat Amount",
    off: "off",
    minutes: "minutes",
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    bookForUser: "Book for User",
    bookAppointment: "Book Appointment",
    selectUser: "Select User",
    enterUserDetails: "Enter User Details",
    userExists: "User Exists",
    newUser: "New User",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    mobile: "Mobile",
    dateOfBirth: "Date of Birth",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    selectAppointment: "Select Appointment",
    selectDate: "Select Date",
    selectTime: "Select Time",
    availableSlots: "Available Time Slots",
    bookingSummary: "Booking Summary",
    totalPrice: "Total Price",
    confirmBooking: "Confirm Booking",
    doubleBookingConfirm:
      "This time slot ({{date}} at {{time}}) already has {{count}} booking(s): {{names}}.\n\nAre you sure you want to book another appointment in this slot?",
    doubleBookingWarning:
      "This time slot already has {{count}} booking(s): {{names}}. You can still proceed, but a confirmation will be required.",
    bookingSuccess: "Appointment booked successfully!",
    bookingError: "Failed to book appointment",
    userNotFound: "User not found",
    noAvailableSlots: "No available time slots for selected date",
    pleaseSelectUser: "Please select a user or enter user details",
    pleaseSelectAppointment: "Please select an appointment type",
    pleaseSelectDate: "Please select a date",
    pleaseSelectTime: "Please select a time slot",
    loadingTimeSlots: "Loading available time slots…",
    noTimeSlotsAvailable: "No time slots available for this date. Try another date.",
    chooseFromSlots: "Choose from available slots",
    enterCustomTime: "Enter custom time",
    customTimeHint:
      "Enter any time (e.g. outside regular hours or when no slots are listed).",
    customTimeInvalid: "Please enter a valid time (HH:MM).",
    customTimeOutsideSlots:
      "This time is not in the listed slots for this date. You can still book it as a custom time.",
    customTimeBadge: "custom time",
    useCustomTimeHint:
      "No slots listed? Switch to “Enter custom time” to book any time.",
    bookStepAppointment: "Appointment type",
    bookStepSchedule: "Date & time",
    bookStepCustomer: "Customer details",
    morningLabel: "Morning",
    afternoonLabel: "Afternoon",
    eveningLabel: "Evening",
    nightLabel: "Night",
    slotsAvailable: "{{count}} available",
    noSlotsInPeriod: "No slots in this period",
    selectedSchedule: "Selected",
    scheduleHint: "Pick a date, then choose a slot or enter a custom time.",
    timeSlotsError: "Could not load time slots. Please try again.",
    staffOnlyDateHint:
      "Staff-only appointment: pick any future date manually. The public open-days calendar may not apply to this type.",
    staffBookingDateHint:
      "Pick any future date. Available times for that date are loaded from the server.",
    userDetailsRequired: "User details are required for new users",
    appointmentDetailsRequired: "Appointment details are required",
    bookingDetailsRequired: "Booking details are required",
    // Validation messages
    appointmentNameRequired: "Appointment name is required",
    descriptionRequired: "Description is required",
    priceRequired: "Price is required",
    discountValueRequired: "Discount value is required",
    discountPercentageLimit: "Percentage discount must be less than 100%",
    startDateRequired: "Start date is required",
    endDateRequired: "End date is required",
    endDateAfterStartDate: "End date must be after start date",
    startTimeRequired: "Start time is required",
    endTimeRequired: "End time is required",
    endTimeAfterStartTime: "End time must be after start time",
    recurringDaysRequired: "Please select at least one recurring day",
    // Modal translations
    editAppointment: "Edit Appointment",
    discountSettings: "Discount Settings",
    recurringSettings: "Recurring Settings",
    finalPrice: "Final Price",
    updateAppointment: "Update Appointment",
    createAppointment: "Create Appointment",
    bookingsViewSplit: "Split",
    bookingsViewList: "List only",
    bookingsViewCalendar: "Calendar only",
    bookingsLayoutLabel: "Screen layout",
    bookingsLayoutGroupLabel: "Booking screen layout",
    bookingsListTitle: "Booking list",
    bookingsScheduleTitle: "Schedule calendar",
    calendarRangeLabel: "Calendar range",
    calendarRangeGroupLabel: "Calendar period",
    calendarViewDay: "Day",
    calendarViewWeek: "Week",
    calendarViewMonth: "Month",
    calendarPrevious: "Previous period",
    calendarNext: "Next period",
    calendarNoBookingsDay: "No bookings",
    bookingsDateInputsLockedHint:
      "In split or calendar-only layout the date range follows the calendar (prev / next / today). Switch to \"List only\" to set dates manually.",
    bookingsCalendarTruncationHint:
      "Showing up to {{limit}} bookings from the server for this period; {{total}} match your filters. Narrow the period or filters if needed.",
    bookingsRefreshing: "Updating bookings…",
    appointmentDetailsTitle: "Appointment Details",
    blockTimeTitle: "Block Time",
    editBlockedTimeTitle: "Edit Blocked Time",
    cancellationReasonLabel: "Cancellation Reason:",
    markComplete: "Mark Complete",
    cancelAppointment: "Cancel Appointment",
    statusUpdated: "Status updated successfully",
    bookingCancelled: "Booking cancelled successfully",
    failedUpdateStatus: "Failed to update status",
    failedCancelBooking: "Failed to cancel booking",
    appointmentName: "Name:",
    appointmentPrice: "Price:",
    blockEntireDay: "Block entire day?",
    blockFromTime: "Block from",
    blockUntilTime: "Block until",
    blockTimeRequired: "Block start and end times are required for partial blocks.",
    closedFullDay: "Closed Full Day",
    partialDayBlocked: "Partial Day Blocked",
    partialDayBlockedRange: "Blocked {{from}}–{{to}}",
    openingTime: "Opening Time",
    closingTime: "Closing Time",
    descriptionReason: "Description / Reason",
    saveBlock: "Save Block",
    updateBlock: "Update Block",
    deleteBlock: "Delete Block",
    confirmDeleteBlock: "Are you sure you want to delete this block?",
    blockSaved: "Time blocked successfully",
    blockUpdated: "Block updated successfully",
    blockDeleted: "Block deleted successfully",
    blockFailed: "Failed to save block",
  },
  sidebar: {
    pharmacyUser: "Pharmacy User",
    administrator: "Administrator",
    standardUser: "Standard User",
    selectPharmacy: "Select Pharmacy",
    mainNavigation: "Main Navigation",
    version: "somaplus Pharmacy Dashboard v{{version}}",
  },
  bookings: {
    title: "Bookings",
    createBooking: "Create New Booking",
    searchPlaceholder: "Search by Name, Email or Test...",
    selectDate: "Select Date",
    serialNumber: "Sr. No.",
    fullName: "Full Name",
    email: "Email",
    testName: "Test Name",
    price: "Price",
    bookingDateTime: "Booking Date & Time",
    startedTestAt: "Started Test At",
    finishedTestAt: "Finished Test At",
    status: "Status",
    noBookingsFound: "No bookings found for the selected criteria",
    changeStatus: "Change Booking Status",
    statusTypes: {
      open: "Open",
      started: "Started",
      finished: "Finished",
      manuallyCancelled: "Manually Cancelled",
      autoCancelled: "Auto Cancelled",
    },
    actions: {
      start: "Start",
      finish: "Finish",
      reschedule: "Re-schedule",
      cancel: "Cancel",
    },
    confirmCancel:
      'Are you sure you want to cancel the booking for "{{name}}"?',
    patientInformation: "Patient Information",
    name: "Name",
    gender: "Gender",
    dateOfBirth: "Date Of Birth",
    age: "Age",
    totalPrice: "Total Price",
    incTax: "(inc. tax)",
    bookingDetails: "Booking Details",
    selectedLabTests: "Selected Tests",
    startTest: "Start Test",
    startTestNow: "Start the test now",
    barcodeLabel: "Code From Barcode Scanner",
    barcodePlaceholder: "Scan or enter barcode",
    requiredDocuments: "Required Document Signatures",
    privacyPolicyConfirmation:
      "I confirm that the patient has signed the Privacy Policy document.",
    disclaimerConfirmation:
      "I confirm that the patient has signed the Disclaimer document.",
    consentFormConfirmation: "I confirm that the patient has paid the Test.",
    testStartedSuccess: "Test started successfully!",
    startDiscount: {
      enable: "Apply discount when starting",
      percentage: "Percentage (%)",
      flat: "Fixed amount (€)",
      preview: "Price after discount: {{original}} → {{final}}",
      catalogDiscountApplied: "Catalog price was",
    },
    errorStartingBooking: "Error starting booking: {{error}}",
    patientDetailsUpdated: "Patient details updated successfully!",
    errorUpdatingPatient: "Error updating patient details: {{error}}",
    editPatientDetails: "Edit Patient Details",
    fillRequiredFields: "Please fill all required fields",
    emailRequired: "Email is required",
    cancelled: "Booking Cancelled!",
    finishTest: "Finish Test",
    barcode: "Barcode",
    clickToRevealBarcode: "Click to reveal",
    noBarcode: "No barcode",
    statusOpen: "Open",
    statusStarted: "Started",
    statusCancelled: "Cancelled",
    statusAutoCancelled: "Auto Cancelled",
    starting: "Starting...",
    finishTestModal: {
      barcode: "Barcode",
      scanBarcode: "Scan or type the patient's barcode to continue",
      cancel: "Cancel",
      next: "Next",
      validating: "Validating...",
      bookingDetails: "Booking Details",
      verifyPatient: "Verify patient information before proceeding",
      fullName: "Full Name",
      dateOfBirth: "Date of Birth",
      gender: "Gender",
      email: "Email",
      labTests: "Tests",
      back: "Back",
      testResults: "Test Results",
      enterResults: "Enter the results for each testparameter",
      resultValue: "Result Value",
      enterValue: "Enter value",
      saving: "Saving...",
      preview: "Preview",
      previewGenerating: "Generating preview PDF…",
      previewReady: "Preview ready — not saved.",
      openPreview: "Open preview PDF",
      previewError: "Error generating preview",
      completeTest: "Complete Test",
      fillAllResults: "Please fill all test results",
      atLeastOneResult: "Please enter at least one result",
      resultsSuccess: "Test results saved successfully",
      resultError: "Error saving test results",
      useCutoff: "Use cutoff value",
      testDetails: "Test Details",
      referenceValues: "Reference Values",
      property: "Property",
      value: "Value",
      testId: "Test ID",
      groupName: "Group Name",
      unitMeasuredIn: "Unit Measured In",
      rangeInputType: "Range Input Type",
      cutoffValue: "Cutoff Value",
      pairedRange1: "Paired Range 1",
      pairedRange2: "Paired Range 2",
      pairedRange3: "Paired Range 3",
      pairedRange4: "Paired Range 4",
      numberOfPairedRanges: "Number of Paired Ranges",
      notSpecified: "Not specified",
      range: "Range",
      category: "Category",
      explanation: "Explanation",
      noReferenceData: "No reference data available",
      male: "Male",
      female: "Female",
      both: "Both",
      allAgeGroups: "All age groups",
      age: "Age",
      reviewConfirm: "Review & Confirm",
      reviewDescription: "Review the results below before saving. This will complete the test and generate the report.",
      missingResultsTitle: "Missing results",
      missingResultsDescription: "The following values have not been entered yet. You can go back to fill them in, or save anyway with the values provided.",
      missingCount: "{{count}} value(s) missing",
      noResultsEntered: "No values entered",
      confirmSave: "Confirm & Save",
      editResults: "Edit Results",
      resultPreview: "Results to be saved",
      enteredValue: "Entered value",
      referenceCategory: "Reference category",
      referenceMeaning: "What this means",
      noReferenceMatch: "No matching reference range for this value",
      noReferenceAvailable: "No reference data — value will be saved as entered",
      cutoffApplied: "Cutoff value applied",
      usingCutoff: "Using cutoff",
      outOfRange: "Outside reference ranges",
      patientContext: "Patient: {{gender}}, age {{age}}",
      errorFlag: "Error",
      errorResultMessage:
        "Unfortunately, the test could not be evaluated properly and must be repeated.",
    },
    rescheduleModal: {
      title: "Reschedule Booking",
      currentBooking: "Current Booking",
      newBooking: "New Booking",
      selectDate: "Select Date",
      selectTime: "Select Time",
      fillAllFields: "Please select both date and time",
      success: "Booking rescheduled successfully",
      error: "Error rescheduling booking: {{error}}",
      confirm: "Confirm Reschedule",
    },
    downloadReport: "Download Report",
    resendEmail: "Resend Email",
    emailResentSuccess: "Email sent successfully!",
    emailResentError: "Failed to send email: {{error}}",
    customerBookingsSchedule: "Bookings overview",
    bookingsLayoutLabel: "Screen layout",
    bookingsLayoutGroupLabel: "Booking screen layout",
    bookingsViewSplit: "Split",
    bookingsViewList: "List only",
    bookingsViewCalendar: "Calendar only",
    bookingsListTitle: "Booking list",
    bookingsScheduleTitle: "Schedule calendar",
    calendarRangeLabel: "Calendar range",
    calendarRangeGroupLabel: "Calendar period",
    calendarViewDay: "Day",
    calendarViewWeek: "Week",
    calendarViewMonth: "Month",
    calendarPrevious: "Previous period",
    calendarNext: "Next period",
    calendarNoBookingsDay: "No bookings",
    today: "Today",
    bookingsDateInputsLockedHint:
      "Split and calendar-only views use the calendar (prev / today / next) for the date range. Switch to list only to use the date picker above.",
    bookingsRefreshing: "Updating bookings…",
  },
  bookingForm: {
    addNewBooking: "Add New Booking",
    selectUser: "Enter Email",
    userDetails: "User Details",
    newUserDetails: "New User Details",
    searchUserPlaceholder: "Start typing to search or create a user",
    firstName: "First Name",
    lastName: "Last Name",
    dateOfBirth: "Date of Birth",
    gender: "Gender",
    selectGender: "Select Gender",
    male: "Male",
    female: "Female",
    postalCode: "Postal Code",
    phoneNumber: "Phone Number",
    mobile: "Mobile",
    selectLabTest: "Select Test",
    searchLabTestPlaceholder: "Search and select a test",
    totalPrice: "Total Price",
    originalPrice: "Original Price",
    applyDiscount: "Apply discount",
    applyDiscountHint:
      "Optional discount on top of catalog prices. Stored on the booking for analytics.",
    incTax: "incl. tax",
    selectDateTime: "Select Date and Time",
    startTestNow: "Start the test now?",
    codeFromBarcodeScanner: "Code From Barcode Scanner",
    reviewBookingDetails: "Review Booking Details",
    editDetails: "Edit Details",
    saveBooking: "Save Booking",
    saving: "Saving...",
    bookingSummary: "Booking Summary",
    name: "Name",
    age: "Age",
    appointment: "Appointment",
    selectedLabTests: "Selected Tests",
    notSpecified: "Not specified",
    staffBooking: "Staff booking",
    staffBookingLabel: "This is a staff booking",
    staffBookingHint:
      "For pharmacy team members. Patient consent is not required when starting the test.",
    bookingCreatedSuccess: "Booking created successfully!",
    errorCreatingBooking: "Error creating booking: {{error}}",
    errors: {
      selectLabTest: "Please select a test.",
      fillUserDetails: "Please fill out all user details.",
    },
    labTestBookingDetailsTitle: "Lab Test Booking Details",
    testDetails: "Test Details",
    testsLabel: "Tests:",
    emailSent: "Email sent successfully",
    failedSendEmail: "Failed to send email",
    editPatientDetails: "Edit Patient Details",
    resendEmail: "Resend Email",
  },
  labTests: {
    title: "Testparameters",
    addNew: "Add New Test",
    editTest: "Edit Test",
    searchPlaceholder: "Search by Test...",
    serialNumber: "Serial No.",
    labTestName: "Test Name",
    price: "Price",
    discountedPrice: "Discounted Price",
    status: "Status",
    statusActive: "Active",
    statusInactive: "Inactive",
    addedOn: "Added On",
    totalRecords: "Total Records",
    confirmDelete: 'Are you sure you want to delete "{{name}}"?',
    discountTooltip: "Discounted price = Original price × Discount percentage",
    modal: {
      selectTest: "Select Test",
      searchAndSelectTest: "Search and select a test",
      pleaseSelectTest: "Please select a test.",
      setPrice: "Set Price (€ - inc. tax)",
      setCustomPrice: "Set Custom Price (€ - inc. tax)",
      enterPrice: "Enter price",
      enterCustomPrice: "Enter custom price",
      priceRequired: "Price is required!",
      testAddedSuccess: "Test '{{name}}' added successfully!",
      testUpdatedSuccess: 'Test "{{name}}" updated successfully!',
      enableDiscount: "Enable Discount",
      discountType: "Discount Type",
      percentage: "Percentage",
      discountedPrice: "Discounted Price",
      discountPercentage: "Discount Percentage",
      enterDiscountPercentage: "Enter discount percentage (0-100)",
      enterDiscountedPrice: "Enter discounted price",
      discountPercentageRequired:
        "Discount percentage is required and must be between 0-100!",
      discountedPriceRequired:
        "Discounted price is required and must be less than original price!",
      calculatedPrice: "Calculated Price",
      calculatedPercentage: "Calculated Percentage",
      discountCalculation: "Discount Calculation",
      originalPrice: "Original Price",
      discountAmount: "Discount Amount",
      finalPrice: "Final Price",
    },
    deleted: "Test Deleted!",
  },
  pharmacySettings: {
    title: "Pharmacy Details",
    description:
      "Enter the basic information about your pharmacy that will be displayed to customers.",
    directBookingLinks: "Direct Booking Links",
    directBookingDescription:
      "Use these links to allow customers to book directly with your pharmacy.",
    walkInLinks: "Walk-In URL",
    walkInDescription:
      "Use these links for walk-in bookings at your pharmacy.",
    walkInEnabled: "Enable Walk-In URL",
    englishWalkInURL: "English Walk-In URL",
    germanWalkInURL: "German Walk-In URL",
    englishURL: "English Booking URL",
    germanURL: "German Booking URL",
    copyToClipboard: "Copy URL",
    pharmacyDetails: "Pharmacy Details",
    pharmacyName: "Pharmacy Name",
    mobilePhone: "Mobile / Phone Number",
    address: "Address",
    addressDescription:
      "Enter your pharmacy's physical address for customer reference and shipping.",
    houseNumber: "House Number",
    street: "Street",
    postalCode: "Postal Code",
    city: "City",
    state: "State",
    country: "Country",
    taxDetails: "Tax Details",
    taxDescription:
      "Enter your pharmacy's tax information for invoicing and regulatory purposes.",
    taxInfo:
      "This information will be used for tax documentation and reporting.",
    vatId: "VAT ID",
    updatePharmacyDetails: "Update Pharmacy Details",
    updating: "Updating...",
    noPharmacyDetails: "No Pharmacy Details Available",
    contactAdmin:
      "Please contact an administrator to set up your pharmacy details.",
    isPubliclyListable: "Publicly listable",
  },
  dashboard: {
    title: "Dashboard",
    selectDate: "Select Date",
    selectDateRange: "Select Date Range",
    switchToAdminView: "Switch to Admin View",
    switchToTeamView: "Switch to Team Dashboard View",
    refreshData: "Refresh Data",
    totalBooking: "Total Bookings",
    totalRevenue: "Total Revenue",
    totalPatients: "Total Patients",
    bookingsCreated: "Bookings Created",
    bookingsStarted: "Bookings Started",
    bookingsFinished: "Bookings Finished",
    bookingsCancelled: "Bookings Cancelled",
    noUpcomingBookings: "No upcoming bookings",
    upcomingBookings: "Upcoming Bookings",
    dashboardStartTest: "Start Test",
    retryTest: "Retry Test",
    finishTest: "Finish Test",
    noBookingsFound: "No bookings found with status: {{status}}",
    statusOpen: "Open",
    statusStarted: "Started",
    statusFinished: "Finished",
    statusManualCancelled: "Manually Cancelled",
    statusAutoCancelled: "Auto Cancelled",
    lastUpdated: "Last updated",
    topLabTestsUsed: "Top Tests Used",
    bookingsByStatus: "Bookings by Status",
    unattendedBookings: "Unattended Bookings",
    cancelledBookings: "Cancelled Bookings",
    openBookings: "Open Bookings",
    pendingBookings: "Pending Bookings",
    completedBookings: "Completed Bookings",
    bookingActivity: "Booking Activity",
    allBookings: "All Bookings",
    performedTests: "Performed Tests",
    totalBookingsVsRevenue: "Total Bookings vs Revenue",
    topLabTestsByBookingCount: "Top 3 Parameters by Booking Count",
    bookingCount: "Booking Count",
    bookingStatusBreakdown: "Booking Status Breakdown",
    time: "Time",
    countRevenue: "Count / Revenue",
    error: "Error: {{message}}",
    upcoming: "Upcoming",
    approaching: "Approaching",
    missed: "Missed",
    inProgress: "In Progress",
    extended: "Extended",
    overdue: "Overdue",
    cancelled: "Cancelled",
    noTestsInProgress: "No tests currently in progress.",
    noManuallyCancelledBookings: "No manually cancelled bookings to display.",
    noAutoCancelledBookings: "No auto-cancelled bookings to display.",
    noBookingData: "No booking data is available.",
    reschedule: "Re-schedule",
    view: "View",
    patientInformation: "Patient Information",
    timeAndStatus: "Time & Status",
    duration: "Duration",
    today: "Today",
    yesterday: "Yesterday",
    next2Days: "Next 2 days",
    last3Days: "Last 3 days",
    past: "Last {{period}} days",
    currentMonth: "This Month",
    pastMonth: "Last Month",
    lastYear: "Last Year",
    thisYear: "This Year",
    last5Years: "Last 5 Years",
    due: "Due in",
    lateBy: "Late by",
    pharmacyDashboard: "Pharmacy Dashboard",
    adminDashboard: "Admin Dashboard",
    viewStatisticsAndAnalytics:
      "View statistics and analytics for your pharmacy",
    checkBookings: "Check Bookings",
    bookWalkIn: "Book Walk-In",
    testsInProgress: "Tests In Progress",
    manuallyCancelledBookings: "Manually Cancelled Bookings",
    autoCancelledBookings: "Auto Cancelled Bookings",
    manageBookingsForDate: "Manage bookings and tests for {{date}}",
  },
  leaderboard: {
    badge: "Performance",
    title: "Pharmacy Leaderboard",
    subtitle:
      "See how your pharmacy ranks by completed tests. Other pharmacies stay anonymous.",
    thisMonth: "This month",
    lastMonth: "Last month",
    thisWeek: "This week",
    lastWeek: "Last week",
    periodRange: "{{start}} to {{end}}",
    rank: "Rank",
    pharmacy: "Pharmacy",
    tests: "Tests",
    yourPharmacy: "Your Pharmacy",
    anonymousPharmacy: "Pharmacy at rank {{rank}}",
    yourRank: "Your current rank",
    outOfPharmacies: "Out of {{total}} pharmacies",
    testsCompleted: "{{count}} tests completed",
    inTopTenSummary:
      "You are ranked #{{rank}} with {{count}} tests out of {{total}} pharmacies.",
    networkTrends: "Top tests across the network",
    yourTrends: "Your top tests",
    noTrendData: "No network test trends for this period yet.",
    noYourTrendData: "No completed tests for your pharmacy in this period yet.",
    noData: "No leaderboard data for this period yet.",
    expand: "Expand",
    collapse: "Collapse",
    collapsedHint: "Tap to view",
    collapsedRank: "Rank #{{rank}}",
    collapsedEmpty: "Complete tests this period to appear on the leaderboard.",
    loadingSummary: "Loading your rank…",
    inTopTenBadge: "Top 10",
    topTestShort: "Top: {{name}} ({{count}})",
  },
  languages: {
    english: "English",
    german: "German",
  },
  profileSettings: {
    title: "Profile Settings",
    subtitle:
      "Update your personal information and preferences. Your profile details are used throughout the system.",
    personalInfo: "Personal Information",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email ID",
    emailNotEditable: "Email address cannot be changed",
    mobile: "Mobile / Phone Number",
    preferences: "Regional Preferences",
    language: "Language",
    languageDescription:
      "Your preferred language for notifications and interface",
    timezone: "Timezone",
    cetTimezone: "Central European Time (CET)",
    timezoneDescription: "Used for scheduling and time-based notifications",
    updateButton: "Update Profile",
    profileUpdated: "Profile Updated",
    languageUpdated: "Language Updated",
    notAvailable: "Profile Not Available",
    loginAgain:
      "Please log in again or contact an administrator if the issue persists.",
  },
  days: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
  },
  scheduleSettings: {
    calendarConnection: "Calendar Connection",
    calendarConnectionDesc:
      "Connect your calendar to sync pharmacy availability with your external calendar system.",
    connectCalendar: "Connect Calendar",
    connecting: "Connecting...",
    calendarConnected: "Calendar Connected",
    connectedCalendar: "Connected Calendar",
    disconnect: "Disconnect",
    disconnecting: "Disconnecting...",
    calendarName: "Calendar Name",
    timeZone: "Time Zone",
    syncStatus: "Sync Status",
    synced: "Synced",
    notSynced: "Not synced",
    noCalendarConnected:
      "No calendar connected yet. Please connect a calendar.",
    connectingCalendar: "Connecting to calendar...",
    pharmacyIdNotFound: "Pharmacy ID not found",
    calendarConnectionFailed: "Failed to connect calendar",
    calendarDisconnected: "Calendar disconnected successfully!",
    disconnectFailed: "Failed to disconnect calendar",
    refreshingCalendarData: "Refreshing calendar data...",
    calendarDataRefreshed: "Calendar data refreshed",
    refreshFailed: "Failed to refresh calendar data",
    loadingCalendarDetails: "Loading calendar details...",
    noCalendarIdProvided: "No calendar ID provided",

    weeklyHours: "Weekly Hours",
    openingDays: "Opening Days",
    openingDaysDesc:
      "Set your pharmacy's regular opening hours for each day of the week.",
    openingTime: "Opening Time",
    closingTime: "Closing Time",
    removeTimeSlot: "Remove time slot",
    addAnotherTimeSlot: "Add another time slot",

    businesshoursonlyforview: "Business Hours for View Only",
    businesshoursonlyforviewDisclaimer:
      "If ON: These hours will only be used to display opening and closing hours. If OFF: These hours will be used for generating appointment slots.",

    openingHoursForAppointments: "Opening Hours for Appointments",
    openingHoursForAppointmentsDesc:
      "Set specific opening hours for appointment bookings. These hours can be different from your general business hours.",

    bookingSettings: "Booking Settings",
    bookingSettingsDesc:
      "Configure how customers can book appointments with your pharmacy.",
    timeSlotInterval: "Time Slot Interval",
    timeSlotIntervalDesc:
      "This determines how appointment slots will be spaced throughout your opening hours.",
    minutes: "{{count}} minutes",

    holidaySettings: "Block certain days",
    holidaySettingsDesc:
      "Set days when your pharmacy will be closed eg. for holidays.",
    addHoliday: "Add Date",
    selectHolidays: "Select dates when your pharmacy will be closed.",
    scheduledHolidays: "Scheduled Closures",
    removeHoliday: "Remove holiday",

    schedulePatterns: "Schedule Patterns",
    schedulePatternsDesc:
      "Set up special schedule rules that follow recurring patterns or custom rules.",
    addSchedulePattern: "Add Schedule Pattern",
    editSchedulePattern: "Edit Schedule Pattern",

    patternType: "Pattern Type",
    dayOfWeek: "Day of Week",
    startDate: "Start Date",
    patternStartDateDesc: "The date from which this pattern will be applied.",
    defaultSetting: "Default Setting",
    alternateWeekly: "Alternate Weekly",
    customPattern: "Custom Pattern",
    alternateWeeklyDesc:
      "The pharmacy will be open every other week on this day.",
    customPatternDesc:
      "Define custom rules for specific dates of this day of the week.",
    startingFrom: "Starting from",
    open: "Open",
    closed: "Closed",
    hours: "Hours",
    specificDates: "Specific Dates",
    date: "Date",
    status: "Status",
    addSpecificDate: "Add Specific Date",
    noSpecificDates: "No specific dates defined",
    noPatterns: "No schedule patterns defined",
    holidays: "Holidays",

    editHoliday: "Edit Holiday",
    description: "Description",
    holidayDescription: "E.g. Christmas Day, Public Holiday",
    descriptionHelp: "Optional description or reason for the holiday/closure",
    addHours: "Add Hours",
    noHoursSet: "No hours set",

    updating: "Updating...",
    updateSchedule: "Update Schedule",
    notificationUpdated: "Pharmacy schedule updated successfully",
  },
  auth: {
    signIn: "Sign In",
    signOut: "Sign Out",
    signUp: "Sign Up",
    forgotPassword: "Forgot Password",
    resetPassword: "Reset Password",
    enterEmail: "Enter your email",
    enterPassword: "Enter your password",
    rememberMe: "Remember me",
    submit: "Submit",
    createAccount: "Create an account",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    loginInstead: "Login instead",
    passwordResetLink: "Password reset link sent to your email",
    passwordResetSuccess: "Password reset successful",
    loginOrSignup: "Login or Sign Up",
    pharmacyDashboardTitle: "Pharmacy Dashboard - Test Booking & Analytics",
    validation: {
      emailRequired: "Email is required!",
      passwordRequired: "Password is required!",
    },
    loggingIn: "Logging in...",
    features: {
      labBooking: "Test booking management",
      labBookingDesc: "with real-time scheduling",
      reports: "Report uploads",
      reportsDesc: "for secure storage and easy access",
      analytics: "Advanced analytics",
      analyticsDesc: "for user activity, booking trends, and test results",
      calendar: "Calendar view",
      calendarDesc: "to easily track test bookings and availability",
      interface: "User-friendly interface",
      interfaceDesc: "with a focus on ease of use and efficient workflow",
    },
  },
  changePassword: {
    title: "Change Password",
    description:
      "Update your password to maintain account security. We recommend using a strong, unique password that you don't use elsewhere.",
    passwordSecurity: "Password Security",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    currentPasswordRequired: "Current Password is required!",
    newPasswordLength: "New Password must be at least 6 characters!",
    passwordsDoNotMatch: "Passwords do not match!",
    hidePassword: "Hide password",
    showPassword: "Show password",
    passwordStrength: "Password Strength",
    requirements: {
      minLength: "At least 8 characters",
      uppercase: "Contains uppercase letters",
      numbers: "Contains numbers",
      special: "Contains special characters",
    },
    passwordsMatch: "Passwords match",
    passwordsDontMatch: "Passwords don't match",
    updatePassword: "Update Password",
    updatingPassword: "Updating Password...",
    passwordUpdatedSuccess: "Password Updated Successfully",
  },
  passwordStrength: {
    veryWeak: "Very Weak",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    veryStrong: "Very Strong",
  },
  team: {
    title: "Team Members",
    teamEmployees: "Team / Employees",
    addNewTeamMember: "Add New Team Member / Employee",
    addNew: "Add New",
    name: "Name",
    emailId: "Email Id",
    mobile: "Mobile",
    role: "Role",
    status: "Status",
    roleTeam: "Team",
    roleUser: "User",
    statusActive: "Active",
    statusInactive: "Inactive",
    accessDenied: "You cannot view the member details. Access Denied",
    avatarAlt: "Avatar",
    deleteConfirmation:
      'Remove "{{name}}" from this pharmacy? If they belong to other pharmacies, their account will remain active there.',
    validation: {
      firstNameRequired: "First Name is required!",
      emailRequired: "Email id is required!",
      passwordRequired: "Password is required for new team members!",
      removeFailed: "Failed to remove team member. Please try again.",
      updateFailed: "Failed to edit the team member. Please try again.",
      addFailed: "Failed to add the team member. Please try again.",
    },
    notifications: {
      memberAdded: "New Team Member Added Successfully!",
      memberUpdated: "Team Member Updated Successfully!",
    },
    form: {
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email Id",
      mobile: "Mobile / Phone Number",
      password: "Password",
      passwordPlaceholder: "Enter Password",
      passwordOptionalHint:
        "Required for new members. Leave blank if adding an existing team member to this pharmacy.",
      generateRandomPassword: "Generate Random Password",
    },
    members: "Team Members",
    addMember: "Add Member",
    editMember: "Edit Member",
    memberDeleted: "Member Deleted!",
    memberRemovedFromPharmacy: "Team member removed from this pharmacy.",
    memberDeletedFully: "Team member removed and account deactivated.",
  },
  transactions: {
    title: "Transactions",
    removeFilter: "Remove Filter",
    name: "Name",
    emailId: "Email Id",
    location: "Location",
    amount: "Amount",
    transactionDate: "Transaction Date",
    totalRecords: "Total Records",
    searchPlaceholder: "Search by name, email...",
  },
  tutorials: {
    title: "Documents",
    description:
      "Learn how to use the pharmacy dashboard with step-by-step documents and guides.",
    comingSoon: "Documents Coming Soon",
    comingSoonDescription:
      "We're working on creating comprehensive documents to help you get the most out of the pharmacy dashboard. Check back soon!",
    viewingAdminDashboard: "You are currently viewing the Admin Dashboard",
    viewingTeamDashboard: "You are currently viewing the Team Dashboard",
    adminDashboardDescription:
      "As an admin, you have access to comprehensive analytics, user management, and system-wide settings.",
    teamDashboardDescription:
      "This view provides access to daily operations, bookings management, and team-specific features.",
    adminTutorials: "Admin Documents",
    adminTutorialsDescription:
      "Comprehensive documents for administrators covering system management, user administration, and advanced features.",
    teamTutorials: "Team Documents",
    teamTutorialsDescription:
      "Essential documents for team members covering daily operations, booking management, and basic features.",
    name: "Name",
    view: "View",
    download: "Download",
    actions: "Actions",
    sampleTutorial1: "User Management Guide",
    sampleDescription1:
      "Learn how to manage users, roles, and permissions in the system.",
    sampleTutorial2: "Analytics & Reporting",
    sampleDescription2:
      "Understand how to generate reports and analyze pharmacy data.",
    sampleTutorial3: "Booking Management",
    sampleDescription3:
      "Step-by-step guide for managing test bookings and appointments.",
    sampleTutorial4: "Daily Operations",
    sampleDescription4:
      "Essential procedures for daily pharmacy operations and workflows.",
    createTutorial: "Create Document",
    noTutorialsFound: "No documents found",
    modal: {
      createTutorial: "Create New Document",
      tutorialType: "Document Type",
      typePdf: "PDF Document",
      typeVideo: "Video Document",
      tutorialName: "Document Name",
      tutorialNamePlaceholder: "Enter document name",
      tutorialDescription: "Description",
      tutorialDescriptionPlaceholder: "Enter document description",
      videoUrl: "Video URL",
      videoUrlPlaceholder: "https://example.com/video.mp4",
      videoUrlHelp: "Enter a valid video URL (YouTube, Vimeo, etc.)",
      uploadPdf: "Upload PDF File",
      uploadFile: "Upload a file",
      orDragDrop: "or drag and drop",
      pdfOnly: "PDF files only, up to 10MB",
      removeFile: "Remove file",
      nameRequired: "Document name is required",
      descriptionRequired: "Description is required",
      fileRequired: "PDF file is required",
      videoUrlRequired: "Video URL is required",
      invalidVideoUrl: "Please enter a valid video URL",
      invalidFileType: "Please upload a PDF file only",
      fileTooLarge: "File size must be less than 10MB",
      tutorialCreatedSuccess: "Document created successfully!",
      tutorialCreatedError: "Error creating document. Please try again.",
    },
    pdfViewer: {
      title: "PDF Viewer",
      loading: "Loading PDF...",
      errorTitle: "Error Loading PDF",
      errorMessage: "Unable to load the PDF file. Please try again.",
    },
    defaultFileName: "document.pdf",
    folders: {
      root: "All Documents",
      folderLabel: "Folder",
      emptyFolder: "This folder is empty.",
    },
  },
};

export default locale;
